<template>
  <div class="ace-header">
    <div class="ace-header__image">
      <img :srcset="`${images['1x']}, ${images['2x']} 2x`" :src="images['1x']" :alt="title" />
    </div>
    <span class="ace-header__name">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ['images', 'title'],
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-header {
  display: flex;
  flex-direction: column;
  &__name {
    @include title;

    margin-top: 25px;
  }
}
</style>
